import React from 'react';
import type { TrustBoxProps } from './types';

export const TrustBoxMini: React.FC<TrustBoxProps> = ({
  ref,
  theme,
  clickable,
  ...rest
}) => (
  <div
    style={clickable ? {} : { pointerEvents: 'none', userSelect: 'none' }}
    ref={ref}
    className="trustpilot-widget"
    data-locale="it-IT"
    data-template-id="53aa8807dec7e10d38f59f32"
    data-businessunit-id="5cacae5d7b08650001e13ded"
    data-style-height="150px"
    data-style-width="100%"
    data-theme={theme}
    {...rest}
  >
    <a
      href="https://it.trustpilot.com/review/dove.it"
      target="_blank"
      rel="noopener noreferrer"
    >
      Trustpilot
    </a>
  </div>
);
